<template>
    <div :data-cy="$attrs['data-cy'] || 'input_label_date_picker'">
        <div class="text-sm" :class="[isError ? 'text-red-500' : 'text-gray-800']" data-cy="text_date_picker_name">
            {{inputLbl.name}}
        </div>

        <div class="relative">
            <div class="flex">
                <div class="flex-1 pr-2">
                    <InputDropdown
                            ref="dropdown-day"
                            v-model:inputValue="dayInput"
                            :itemList="dayList"
                            :errorInfo="errorInfoDate[0]"
                            :isShowError="isShowError"
                            :isSubmitted="isSubmitted"
                            :inputLbl="inputLbl.date"
                            @update:inputValue="onValueUpdate()"
                            data-cy="component_date_picker_day"
                    ></InputDropdown>
                </div>
                <div class="flex-1 pr-2">
                    <InputDropdown
                            ref="dropdown-month"
                            v-model:inputValue="monthInput"
                            :itemList="monthList"
                            :errorInfo="errorInfoDate[1]"
                            :isShowError="isShowError"
                            :isSubmitted="isSubmitted"
                            :inputLbl="inputLbl.month"
                            @update:inputValue="onValueUpdate()"
                            data-cy="component_date_picker_month"
                    ></InputDropdown>
                </div>
                <div class="flex-1">
                    <InputDropdown
                            ref="dropdown-year"
                            v-model:inputValue="yearInput"
                            :itemList="yearList"
                            :errorInfo="errorInfoDate[2]"
                            :isShowError="isShowError"
                            :isSubmitted="isSubmitted"
                            :inputLbl="inputLbl.year"
                            @update:inputValue="onValueUpdate()"
                            data-cy="component_date_picker_year"
                    ></InputDropdown>
                </div>
            </div>
            <!-- error msg -->
            <div class="text-red-500 text-sm absolute bottom-0 left-0" v-if="isError" data-cy="text_date_picker_error">
                {{getErrorMsg}}
            </div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import Locale from "@/helper/locale/Locale.js";
import { FormHelper, DropdownListValue } from "@/helper/FormHelper.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
//components
import InputDropdown from "./InputDropdown.vue";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "DatePickerDropdown",
    components: {
        InputDropdown,
    },
    props: {
        // v-model
        inputValue:     { type: [Date, String, Number] },
        // props
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },
    },
    data: function() {
        return {
            dayInput: null,
            monthInput: null,
            yearInput: null,

            dayList: [],
            monthList: [],
            yearList: [],

            errorInfoDate: FormHelper.genErrorInfo(3),
        };
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid) 
                ? this.errorInfo.msg
                : '';
        }
    },
    created: function() {
        this.setDayList();
        this.setMonthList();
        this.setYearList();
    },
    mounted: function() {
        this.setDateInitial();
        this.onValueUpdate();
    },
    methods: {
        //#region setup
        setDayList: function() {
            let dayListItem = new DropdownListValue();

            for (let i=1 ; i<= 31 ; i++) {
                let d = (i < 10) ? '0' + i : '' + i ;
                dayListItem.add(d, i+'');
            }
            this.dayList = dayListItem.getList();
        },
        setMonthList: function() {
            let monthListItem = new DropdownListValue();

            let lbl = Locale.getLbl();
            let months = lbl.date.month_full;
            for (let i in months) {
                let index = parseInt(i, 10) + 1 + '';
                // let index = parseInt(i, 10) + '';
                monthListItem.add(months[i], index);
            }
            this.monthList = monthListItem.getList();
        },
        setYearList: function() {
            let yearListItem = new DropdownListValue();

            let currentYear = parseInt(new Date().getFullYear(), 10);
            let yearText = currentYear;
            let localeCode = Locale.getLocaleCode();

            if (localeCode == 1054) {
                yearText = yearText + 543;
            }

            for (let i=0 ; i<100 ; i++) {
                yearListItem.add(yearText-i + '', currentYear-i + '');
            }
            this.yearList = yearListItem.getList();
        },
        setDateInitial: function() {
            if (Util.isEmptyStr(this.inputValue)) {
                return;
            }

            let date = null;
            let checkDate = this.inputValue.toString();

            if (this.inputValue instanceof Date) {
                date = this.inputValue;
            } else if (checkDate.match(/^[0-9]+$/)) {
                date = DatetimeHelper.unixTimestampToDate(this.inputValue);
            } else {
                date = DatetimeHelper.stringToDate(this.inputValue, 'YYYY-MM-DD');
            }

            let d = date.getDate();
            let m = date.getMonth() + 1;
            let y = date.getFullYear();

            this.dayInput = d+'';
            this.monthInput = m == 0 ? '0' : m+'';
            this.yearInput = y+'';

            this.$refs['dropdown-day'].setValue(this.dayInput);
            this.$refs['dropdown-month'].setValue(this.monthInput);
            this.$refs['dropdown-year'].setValue(this.yearInput);

            this.validateInput();
        },
        //#endregion setup

        validateInput: function() {
            let dateValidate = FormHelper.validate(this.errorInfoDate);
            // console.log("update validate", dateValidate);

            this.errorInfo.setValid(dateValidate);
            this.errorInfo.setMsg(this.inputLbl.required);
            return dateValidate;
        },

        onValueUpdate: function() {
            if (this.validateInput()) {
                this.checkDateCorrect();

                let inputDate = DatetimeHelper.getDateByValue(this.yearInput, this.monthInput, this.dayInput);
                let timestamp = DatetimeHelper.convertDateToTimeStampUnix(inputDate);
                let formated = DatetimeHelper.dateFullFormat(inputDate);
                let value = {
                    date: inputDate,
                    timestamp: timestamp,
                    formated: formated,
                };
                this.$emit("update:inputValue", timestamp);
                this.$emit("onDateChange", value);
            }
        },
        checkDateCorrect: function() {
            if (!DatetimeHelper.isDatetimeValid(this.yearInput, this.monthInput, this.dayInput)) {
                let correctDay = DatetimeHelper.getEndOfMonthDay(this.yearInput, this.monthInput);
                this.dayInput = correctDay;
                this.$refs['dropdown-day'].setValue(correctDay);
            }
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
